import { Injectable } from '@angular/core';
import jwt_decode from 'jwt-decode';
import { Observable, of } from 'rxjs';
import { Filter } from 'libs/portal/src/models/Filter';
import { Md5 } from 'ts-md5';
// import { google } from 'google-maps';

@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  maxCSQ = 5;
  static ValidateRange(range: string, input) {
    const regex = /^((([0-9]+-[0-9]+)|[0-9]+),)*(([0-9]+-[0-9]+)|[0-9]+)$/;
    const passed = regex.test(range);
    if (!passed) {
      input.target.invalid = true;
    }
  }

  static BuildURLParameters = (url: string, obj: any, checkForExisting = false) => {
    if (obj == null || (Object.keys(obj).length === 0 && obj.constructor === Object)) {
      return url;
    }

    const obkeys = [];
    const obvals = [];
    if (checkForExisting) {
      const temp = url.split('?');
      if (temp.length > 1) {
        const tempKeyVals = temp[1].split('&');
        tempKeyVals.forEach((el) => {
          const k = el.split('=');
          obkeys.push(k[0]);
          obvals.push(k[1]);
        });
      }
      url = temp[0];
    }

    for (const key in obj) {
      if (obj[key] === null || obj[key] == undefined) {
        continue;
      }
      obkeys.push(key);
      switch (typeof obj[key]) {
        case 'string':
          obvals.push(obj[key]);
          break;
        case 'number':
          obvals.push(obj[key].toString());
          break;
        case 'boolean':
          obvals.push(obj[key] === true ? 'true' : 'false');
          break;
        default:
      }
    }

    if (obkeys.length > 0) {
      url += '?';
      for (let i = 0; i < obkeys.length; i++) {
        if (i != 0) {
          url += '&';
        }
        url += obkeys[i] + '=' + obvals[i];
      }
    }

    return url;
  };

  CreateInterval(minutes: number, func: (a) => void, scope: any): any {
    return setInterval(() => {
      if (func != null) {
        func(scope);
      }
    }, minutes * 1000 * 60);
  }

  DestroyInterval(inter: any) {
    if (inter != null) {
      clearInterval(inter);
    }
  }

  formatBytes(bytes) {
    return (bytes / 1000).toFixed(0) + 'MB';
  }

  FormatBundleUsage(bytes: number): string {
    const unit = 1000.0;
    if (bytes < unit) {
      return bytes + ' MB';
    }
    let div = unit;
    let exp = 0;
    for (let i = bytes / unit; i >= unit; i /= unit) {
      div *= unit;
      exp++;
    }
    return (Math.round((bytes / div) * 100) / 100).toFixed(2) + ' ' + 'kMGTPE'[exp] + 'B';
  }

  FormatUsage(bytes: number): string {
    if (!bytes) {
      bytes = 0;
    }
    const unit = 1000.0;
    if (bytes < unit) {
      return bytes + ' B';
    }
    let div = unit;
    let exp = 0;
    for (let i = bytes / unit; i >= unit; i /= unit) {
      div *= unit;
      exp++;
    }
    return (Math.round((bytes / div) * 100) / 100).toFixed(2) + ' ' + 'kMGTPE'[exp] + 'B';
  }

  ConvertDataFromBytes(bytes: number, unit: string): number {
    bytes = +bytes;
    if (unit == 'B') {
      return bytes;
    } else if (unit == 'KB') {
      return bytes * Math.pow(10, -3);
    } else if (unit == 'MB') {
      return bytes * Math.pow(10, -6);
    } else if (unit == 'GB') {
      return bytes * Math.pow(10, -9);
    } else if (unit == 'TB') {
      return bytes * Math.pow(10, -12);
    } else if (unit == 'PB') {
      return bytes * Math.pow(10, -15);
    }
  }

  CalculateUsages(usages, rounding = 0) {
    const calculatedUsages = this.GetZeroArray(usages.length);
    for (let i = 0; i < usages.length; i++) {
      if (i == 0) {
        calculatedUsages[0] = usages[0].toFixed(rounding);
      } else {
        const temp = parseFloat(calculatedUsages[i - 1]) + usages[i];
        calculatedUsages[i] = temp.toFixed(rounding);
      }
    }
    return calculatedUsages;
  }

  //Not Used
  // StringToBytesWithObject = (value: string): string => {
  // 	return this.StringToBytes(value);
  // };

  StringToBytes = (value: string): string => {
    const bytes = Number(value);

    if (bytes > Math.pow(1000, 4)) {
      return String(bytes / Math.pow(1000, 4)) + ' T';
    } else if (bytes > Math.pow(1000, 3)) {
      return String(bytes / Math.pow(1000, 3)) + ' G';
    } else if (bytes > Math.pow(1000, 2)) {
      return String(bytes / Math.pow(1000, 2)) + ' M';
    } else if (bytes > 1000) {
      return String(bytes / 1000) + ' K';
    }
    return value + ' B';
  };

  RandomRGBA(r: number, g: number, b: number) {
    const o = Math.round,
      rand = Math.random;
    return 'rgba(' + o(rand() * r) + ',' + o(rand() * g) + ',' + o(rand() * b) + ',' + rand().toFixed(1) + ')';
  }

  RandomNumber(r: number) {
    const o = Math.round,
      rand = Math.random;
    return o(o(rand() * r) + rand());
  }

  GenerateRandomColor(): string {
    return this.RandomRGBA(Math.random() * 240 + 10, Math.random() * 240 + 10, Math.random() * 240 + 10);
  }

  RemoveQuotes = (value: string): string => {
    return value != null ? value.replace(/['"]+/g, '') : '-';
  };

  //Not Used
  // RemoveExtension = (obj: Object, value: string): string => {
  // 	if (value != null) {
  // 		const parts = value.split(".");
  // 		if (parts && parts.length > 0) {
  // 			return parts[0];
  // 		}
  // 	}
  // 	return value;
  // };

  GetStartOfMonth(date: Date): Date {
    const newDate = new Date(date.getFullYear(), date.getMonth(), 1);
    newDate.setHours(0, 0, 0);
    return newDate;
  }

  GetEndOfMonth(): Date {
    const today = new Date();
    const date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    date.setUTCHours(23, 59, 59);
    return date;
  }

  GetEndOfMonthFromDate(d: Date): Date {
    const today = d;
    const date = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    date.setUTCHours(23, 59, 59);
    return date;
  }

  FormatStartDate = (oldFormat: string): string => {
    const theDate: Date = new Date(oldFormat);
    theDate.setHours(2, 0, 0, 0);
    return theDate.toISOString();
  };

  FormatEndDate = (oldFormat: string): string => {
    const theDate: Date = new Date(oldFormat);
    theDate.setDate(theDate.getDate() + 1);
    theDate.setHours(1, 59, 59, 999);
    return theDate.toISOString();
  };

  CopyToClipboard(value: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = value;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  GetTimeFilters(): Observable<Filter[]> {
    return of([
      { iD: 1, name: 'Minute' },
      { iD: 2, name: '5 Minutes' },
      { iD: 3, name: '30 Minutes' },
      { iD: 4, name: 'Hour' },
      { iD: 5, name: 'Day' },
      { iD: 6, name: 'Week' },
      { iD: 7, name: 'Month' },
    ]);
  }

  GetTimeFiltersLargeDataSet(): Observable<Filter[]> {
    return of([
      { iD: 4, name: 'Hour' },
      { iD: 5, name: 'Day' },
      { iD: 6, name: 'Week' },
      { iD: 7, name: 'Month' },
    ]);
  }

  FormatDateTime(d: any): string {
    const dformat = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-') + ' ' + [d.getHours(), d.getMinutes(), d.getSeconds()].join(':');
    return dformat;
  }

  FormatSwedishDateTime(d: Date): string {
    return d.toLocaleString('sv-SE');
  }

  FormatSwedishDate(d: Date): string {
    return d.toLocaleDateString('sv-SE');
  }

  FormatDate(d: any): string {
    const dformat = [d.getFullYear(), d.getMonth() + 1, d.getDate()].join('-');
    return dformat;
  }

  ExtractPaginationFromHeaders(headers): number {
    const pagination = JSON.parse(headers.get('x-pagination'));
    if (pagination != null && pagination['TotalCount'] >= 0) {
      return parseInt(pagination['TotalCount']);
    }
    return 0;
  }

  Transform = (value: any): any => {
    return new Date(value);
  };

  CalculateDeviceStatus = (r: Object, fromKey: string, toKey: string) => {
    r[toKey] = r[fromKey];
    const date = this.Transform(r[fromKey]);
    const timeDiff = Math.round((Date.now() - date) / 1000 / 60);
    const statusKey = toKey + 'IsActive';
    if (timeDiff < 10) {
      // Time is within 10 mins
      r[statusKey] = true;
    } else if (timeDiff < 1440) {
      // Time is within 24 hours
      r[statusKey] = null;
    } else {
      // Time is older than 24 hours
      r[statusKey] = false;
    }
  };

  CalculateUsageLevel = (total, usage: number): string => {
    const perc = (total / usage) * 100;
    if (!Number.isNaN(perc) && perc > 0) {
      if (perc < 25) {
        return 'Low';
      } else if (perc < 75) {
        return 'Moderate';
      } else if (perc <= 100) {
        return 'High';
      } else {
        return 'Extreme';
      }
    }
    return 'No';
  };

  GetCurrentMonthName = (): string => {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const d = new Date();
    return monthNames[d.getMonth()];
  };

  GetCurrentYear = (): string => {
    const d = new Date();
    return d.getFullYear().toString();
  };

  GetDateMonthName = (d: Date): string => {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return monthNames[d.getMonth()];
  };

  GetDateYear = (d: Date): string => {
    return d.getFullYear().toString();
  };

  ParseAPIDate = (date: string): Date => {
    const newDate = new Date();
    newDate.setUTCFullYear(parseInt(date.substr(0, 4)));
    newDate.setUTCMonth(parseInt(date.substr(5, 2)) - 1);
    newDate.setUTCMonth(parseInt(date.substr(5, 2)) - 1); // Just leave it, it's necessary for the 6 month graph for some reason
    newDate.setUTCDate(parseInt(date.substr(8, 2)));
    newDate.setUTCHours(parseInt(date.substr(11, 2)));
    newDate.setUTCMinutes(parseInt(date.substr(14, 2)));
    newDate.setUTCSeconds(parseInt(date.substr(17, 2)));
    return newDate;
  };

  ParseAPIDateWithTimezone = (date: string): Date => {
    let newDate = new Date();
    newDate.setFullYear(parseInt(date.slice(0, 4)));
    newDate.setMonth(parseInt(date.slice(5, 7)) - 1);
    newDate.setDate(parseInt(date.slice(8, 10)));
    newDate.setHours(parseInt(date.slice(11, 13)));
    newDate.setMinutes(parseInt(date.slice(14, 16)));
    newDate.setSeconds(parseInt(date.slice(17, 19)));
    return newDate;
  };

  // FormatDateTime()

  FormatDateTimeFromDate(date: Date): string {
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  }

  FormatDateFromDate(date: Date): string {
    return date.toLocaleDateString();
  }

  ConvertEpochToDate(epoch: number): Date {
    const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(epoch);
    return d;
  }

  GetSimIconBasedOnNetworkName(netName: string): string {
    let icon = '';
    switch (netName) {
      case 'Telkom Mobile':
        icon = 'blue';
        break;
      case 'SA - Vodacom':
      case 'LES - Vodacom':
        icon = 'red';
        break;
      case 'SA - Cell C':
        icon = 'black';
        break;
      case 'ZAM - MTN':
      case 'SA - MTN':
      case 'SWZ - MTN':
        icon = 'yellow';
        break;
      default:
        icon = 'grey';
        break;
    }
    return icon + '-sim.png';
  }

  GetMaxCSQ(): number {
    return this.maxCSQ;
  }

  CalculateRadiusDistanceBasedOnCSQ(csq: number, originalDistance: number): number {
    if (originalDistance == null) {
      return 0;
    }

    const distance = originalDistance; //(range == null ? originalDistance : range);

    if (csq >= this.maxCSQ) {
      csq = this.maxCSQ;
    }

    if (csq == null || csq == 0) {
      return distance;
    }

    return (this.invertSignalStrength(csq) / this.maxCSQ) * distance * 1.5;
  }

  invertSignalStrength(csq: number): number {
    switch (csq) {
      case 1:
        return 5;
      case 2:
        return 4;
      case 3:
        return 3;
      case 4:
        return 2;
      case 5:
        return 1;
      default:
        return csq;
    }
  }

  GetNetworkColourByMNC(mnc: number): string {
    switch (mnc) {
      case 1: // Vodacom
        // return "#FA8072";
        return '#EB1900';
      case 2: // Telkom
      case 5: // Telkom
        return '#166BCE';
      case 7: // Cell C
        return '#000000';
      case 10: // MTN
      case 12: // MTN
        return '#F3DB00';
      default:
        return '#666666';
    }
  }

  GetNetworkNameByMNC(mnc: number): string {
    switch (mnc) {
      case 1: // Vodacom
        return 'Vodacom';
      case 2: // Telkom
      case 5: // Telkom
        return 'Telkom';
      case 7: // Cell C
        return 'Cell C';
      case 10: // MTN
      case 12: // MTN
        return 'MTN';
      default:
        return 'Other';
    }
  }

  GetMNCByNetworkName(network: string) {
    network = network.toLowerCase();

    switch (true) {
      case network.includes('vodacom'):
        return [1];
      case network.includes('telkom'):
        return [2, 5];
      case network.includes('cell c'):
        return [7];
      case network.includes('mtn'):
        return [10, 12];
      default:
        return [];
    }
  }

  GetBasicTowerMarkerInfo(mnc: number, type: any, state: boolean = null, checkState = false): any {
    const markerInfo = {
      icon: null,
      name: null,
    };

    let switchVal = ``;

    if (checkState) {
      if (state != null) {
        // Either Online or Offline
        if (state == true) {
          // Online
          switchVal += `${mnc}online`;
        } else {
          // Offline
          switchVal += `${mnc}offline`;
        }
      } else {
        // Pending status
        switchVal += `${mnc}pending`;
      }
    } else {
      switchVal = `${mnc}${type}`;
    }

    const splitSwitch = [`${mnc}`, `${type}`];
    switch (true) {
      // VODACOM
      case switchVal == '1a': // Vodacom Accepted
        markerInfo.icon = 'VodacomAcceptedMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      case switchVal == '1p': // Vodacom Previous
        markerInfo.icon = 'VodacomPreviousMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      case switchVal == '1c': // Vodacom Current
        markerInfo.icon = 'VodacomCurrentMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      case switchVal == '1null': // Vodacom
        markerInfo.icon = 'VodacomMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      case switchVal == '1pending': // Vodacom Pending
        markerInfo.icon = 'VodacomPendingMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      case switchVal == '1online': // Vodacom Online
        markerInfo.icon = 'VodacomOnlineMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      case switchVal == '1offline': // Vodacom Offline
        markerInfo.icon = 'VodacomOfflineMarker.png';
        markerInfo.name = 'Vodacom';
        break;
      // TELKOM
      case switchVal == '2a': // Telkom Accepted
      case switchVal == '5a': // Telkom Accepted
        markerInfo.icon = 'TelkomAcceptedMarker.png';
        markerInfo.name = 'Telkom';
        break;
      case switchVal == '2p': // Telkom Previous
      case switchVal == '5p': // Telkom Previous
        markerInfo.icon = 'TelkomPreviousMarker.png';
        markerInfo.name = 'Telkom';
        break;
      case switchVal == '2c': // Telkom Current
      case switchVal == '5c': // Telkom Current
        markerInfo.icon = 'TelkomCurrentMarker.png';
        markerInfo.name = 'Telkom';
        break;
      case switchVal == '2null': // Telkom
      case switchVal == '5null': // Telkom
        markerInfo.icon = 'TelkomMarker.png';
        markerInfo.name = 'Telkom';
        break;
      case switchVal == '5pending': // Telkom Pending
      case switchVal == '2pending': // Telkom Pending
        markerInfo.icon = 'TelkomPendingMarker.png';
        markerInfo.name = 'Telkom';
        break;
      case switchVal == '2online': // Telkom Online
      case switchVal == '5online': // Telkom Online
        markerInfo.icon = 'TelkomOnlineMarker.png';
        markerInfo.name = 'Telkom';
        break;
      case switchVal == '2offline': // Telkom Offline
      case switchVal == '5offline': // Telkom Offline
        markerInfo.icon = 'TelkomOfflineMarker.png';
        markerInfo.name = 'Telkom';
        break;
      // CELL C
      case switchVal == '7a': // Cell C Accepted
        markerInfo.icon = 'CellCAcceptedMarker.png';
        markerInfo.name = 'Cell C';
        break;
      case switchVal == '7p': // Cell C Previous
        markerInfo.icon = 'CellCPreviousMarker.png';
        markerInfo.name = 'Cell C';
        break;
      case switchVal == '7c': // Cell C Current
        markerInfo.icon = 'CellCCurrentMarker.png';
        markerInfo.name = 'Cell C';
        break;
      case switchVal == '7null': // Cell C
        markerInfo.icon = 'CellCMarker.png';
        markerInfo.name = 'Cell C';
        break;
      case switchVal == '7pending': // Cell C Pending
        markerInfo.icon = 'CellCPendingMarker.png';
        markerInfo.name = 'Cell C';
        break;
      case switchVal == '7online': // Cell C Online
        markerInfo.icon = 'CellCOnlineMarker.png';
        markerInfo.name = 'Cell C';
        break;
      case switchVal == '7offline': // Cell C Offline
        markerInfo.icon = 'CellCOfflineMarker.png';
        markerInfo.name = 'Cell C';
        break;
      // MTN
      case switchVal == '10a': // MTN Accepted
      case switchVal == '12a': // MTN Accepted
        markerInfo.icon = 'MTNAcceptedMarker.png';
        markerInfo.name = 'MTN';
        break;
      case switchVal == '10p': // MTN Previous
      case switchVal == '12p': // MTN Previous
        markerInfo.icon = 'MTNPreviousMarker.png';
        markerInfo.name = 'MTN';
        break;
      case switchVal == '10c': // MTN Current
      case switchVal == '12c': // MTN Current
        markerInfo.icon = 'MTNCurrentMarker.png';
        markerInfo.name = 'MTN';
        break;
      case switchVal == '10null': // MTN
      case switchVal == '12null': // MTN
        markerInfo.icon = 'MTNMarker.png';
        markerInfo.name = 'MTN';
        break;
      case switchVal == '10pending': // MTN Pending
      case switchVal == '12pending': // MTN Pending
        markerInfo.icon = 'MTNPendingMarker.png';
        markerInfo.name = 'MTN';
        break;
      case switchVal == '10online': // MTN Online
      case switchVal == '12online': // MTN Online
        markerInfo.icon = 'MTNOnlineMarker.png';
        markerInfo.name = 'MTN';
        break;
      case switchVal == '10offline': // MTN Offline
      case switchVal == '12offline': // MTN Offline
        markerInfo.icon = 'MTNOfflineMarker.png';
        markerInfo.name = 'MTN';
        break;
      // OTHER MNC
      case splitSwitch[0] !== 'null' && splitSwitch[1] == 'a': // Other Accepted
        markerInfo.icon = 'OtherAcceptedMarker.png';
        markerInfo.name = 'Other';
        break;
      case splitSwitch[0] !== 'null' && splitSwitch[1] == 'p': // Other Previous
        markerInfo.icon = 'OtherPreviousMarker.png';
        markerInfo.name = 'Other';
        break;
      case splitSwitch[0] !== 'null' && splitSwitch[1] == 'c': // Other Current
        markerInfo.icon = 'OtherCurrentMarker.png';
        markerInfo.name = 'Other';
        break;

      case splitSwitch[0] !== 'null' && splitSwitch[1] == 'null': // Other
        markerInfo.icon = 'OtherMarker.png';
        markerInfo.name = 'Other';
        break;

      // GENERIC
      case switchVal == 'nulla': // Generic Accepted
        markerInfo.icon = 'GenericAcceptedMarker.png';
        markerInfo.name = 'Generic';
        break;
      case switchVal == 'nullp': // Generic Previous
        markerInfo.icon = 'GenericPreviousMarker.png';
        markerInfo.name = 'Generic';
        break;
      case switchVal == 'nullc': // Generic Current
        markerInfo.icon = 'GenericCurrentMarker.png';
        markerInfo.name = 'Generic';
        break;

      // DEFAULT
      default:
        markerInfo.icon = 'DefaultMarker.png';
        markerInfo.name = 'Default';
        break;
    }
    return markerInfo;
  }

  ConvertDateToEpoch(d: Date): number {
    return Math.round(d.getTime() / 1000);
  }

  GetZeroArray(len: number): any[] {
    const arr = [];
    for (let i = 0; i < len; i++) arr.push(0);
    return arr;
  }

  GetExpiryTimeFromToken(token: string): Date {
    const decoded = jwt_decode(token);
    const d = new Date(0);
    d.setUTCSeconds(decoded['exp']);
    return d;
  }

  GetTimeDifference(expire: Date): number {
    const now = new Date(Date.now());
    return Math.abs(expire.getTime() - now.getTime());
  }

  AccountingStringType(value): string {
    if (typeof value != 'string') {
      value = value.toString();
    }

    return value.split(/(?=(?:...)*$)/).join(' ');
  }

  /**
   *
   * @param rawString Original string value that needs obfuscating
   * @param prefix Optional string to prepend to the obfuscated value
   * @param suffixLength Amount of characters to generate for obfuscation value
   * @returns Obfuscated string
   */
  Obfuscate(rawString: string, prefix: string, suffixLength: number, suffix?: string): string {
    if (rawString == '' || suffixLength <= 0) {
      return prefix;
    }
    let hash = Md5.hashStr(rawString);
    if (suffixLength > hash.length) {
      suffixLength = hash.length;
    }
    hash = hash.substring(hash.length - suffixLength, hash.length);
    return `${prefix}${hash}${suffix ?? ''}`;
  }

  /**
   *
   * @returns First millisecond of the current month in UTC
   */
  StartOfMonth(): Date {
    const d = new Date();
    d.setUTCDate(1);
    d.setUTCHours(0);
    d.setUTCMinutes(0);
    d.setUTCSeconds(0);
    d.setUTCMilliseconds(0);
    return d;
  }

  /**
   *
   * @returns Last millisecond of the current month in UTC
   */
  EndOfMonth(): Date {
    const d = new Date();
    d.setUTCDate(1);
    d.setUTCHours(0);
    d.setUTCMinutes(0);
    d.setUTCSeconds(0);
    d.setUTCMilliseconds(0);
    return new Date(d.valueOf() - 1);
  }

  calculateProjectionData(graphObject) {
    const tempDataUsed = graphObject['dataUsed'];
    let average = 0.0;
    let daysInMonth;

    if (graphObject.isCumulative != null && graphObject.isCumulative) {
      for (let i = 0; i < tempDataUsed.length; i++) {
        if (i > 0) {
          average += parseFloat(tempDataUsed[i]) - parseFloat(tempDataUsed[i - 1]);
        } else {
          average += parseFloat(tempDataUsed[i]);
        }
      }
    } else {
      for (let i = 0; i < tempDataUsed.length; i++) {
        average += parseFloat(tempDataUsed[i]);
      }
    }

    average = average / parseFloat(tempDataUsed.length);

    const now = graphObject.NewDate ? graphObject.NewDate : new Date();
    daysInMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate();
    for (let i = 0; i < daysInMonth; i++) {
      graphObject.projected[i] = (average * (i + 1)).toFixed(2);
    }

    for (let i = tempDataUsed.length; i < daysInMonth; i++) {
      const parseDate = new Date(new Date().setDate(i + 1));
      graphObject['weeks'].push(parseDate.toLocaleDateString('sv-SE'));
    }

    return { graphObject: graphObject, daysInMonth: daysInMonth };
  }

  getDateFromString(stringDate: string) {
    let date = new Date(stringDate);
    let offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() + offset);
    return date;
  }

  downloadAsCSV(data: any[], filename: string, headers?: string[]) {
    const csvRows = [];

    if (headers == null) {
      headers = Object.keys(data[0]);
    }
    csvRows.push(headers.join(','));
    for (const row of data) {
      const values = headers.map((header) => {
        const val = row[header];
        return `"${val}"`;
      });
      csvRows.push(values.join(','));
    }
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    // if (navigator.msSaveBlob) { // In case of IE 10+
    // 	navigator.msSaveBlob(blob, filename);
    // } else {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    // }
  }

  GetEndOfDay(d: Date): Date {
    let newDate = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    newDate.setDate(newDate.getDate() + 1);
    newDate.setHours(1, 59, 59, 999);
    return newDate;
  }

  FormatDateTimeFromDateSwedish(date: Date): string {
    return date.toLocaleDateString('sv-SE') + ' ' + date.toLocaleTimeString('sv-SE');
  }

  getDateFromStringMinusTimezone(stringDate: string) {
    let date = new Date(stringDate);
    let offset = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - offset);
    return date;
  }

  isoDateWithoutTimeZone(date) {
    if (date == null) return date;
    let timestamp = date.getTime() - date.getTimezoneOffset() * 60000;
    let correctDate = new Date(timestamp);
    return correctDate;
  }

  handleZoom(event: WheelEvent, map: google.maps.Map): void {
    event.preventDefault(); // Prevent default zooming
    map.setOptions({isFractionalZoomEnabled: true});

    if (map) {
      const currentZoom = map.getZoom() || 0;
      // Custom zoom logic
      const zoomStep = 0.1
      if (event.deltaY < 0) {
        map.setZoom(currentZoom + zoomStep); // Zoom in
      } else if (event.deltaY > 0) {
        map.setZoom(currentZoom - zoomStep); // Zoom out
      }
    }
  }
}
